<template>
  <v-dialog v-model="dialog.show" max-width="800" persistent>
    <v-card>
      <v-toolbar :color="this.getAppBarColor" dark>{{ dialog.title }}</v-toolbar>
      <v-card-text>
        <v-data-table
          v-model="selected"
          :headers="headers"
          :items="items"
          single-select
          show-select
          class="elevation-1"
        >
          <template v-slot:item.foto="{ item }">
            <v-img
              contain
              max-height="90"
              max-width="90"
              :src="item.foto ? 'data:image/png;base64,' + item.foto : ''"
            ></v-img>
          </template>
        </v-data-table>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn
          class="ma-3 pl-5 pr-5"
          outlined
          color="blue darken-1"
          small
          dark
          rounded
          depressed
          @click="save()"
        >Salvar</v-btn>

        <v-btn
          class="ma-3 pl-5 pr-5"
          outlined
          color="red darken-2"
          small
          dark
          rounded
          depressed
          @click="close()"
        >Fechar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import Veiculo from "@/services/veiculo";

export default {
  nome: "DialogLeadVeiculos",

  data() {
    return {
      dialog: {
        show: false,
        title: "Selecione um Veiculo"
      },
      serviceVeiculo: new Veiculo(),
      selected: [],
      headers: [
        { text: "", value: "foto" },
        { text: "Veiculo", value: "descricao" }
      ],
      items: [],
      search: ""
    };
  },

  computed: {
    ...mapGetters("auth", ["getUser"])
  },

  methods: {
    async show() {
      try {
        const response = await this.serviceVeiculo.getByFabricante(
          this.getFabricanteEmpresaPrincipal()
        );
        this.items = response;
        this.dialog.show = true;
        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },

    getFabricanteEmpresaPrincipal() {
      return this.getUser.empresas.filter(
        empresa => empresa.cnpj == this.getUser.empresaPrincipal
      )[0].fabricante;
    },

    save() {
      this.$emit("selected", this.selected[0]);
      this.close();
    },

    close() {
      this.dialog.show = false;
    }
  }
};
</script>
